
import {JOB_REQUEST_REQUEST, JOB_REQUEST_SUCCESS,JOB_REQUEST_FAIL} from "../constants/AuthConstant";

const axios = require("axios");
export const JobRequestAction = (id) => {
    return function (dispatch) {
      dispatch({
        type: JOB_REQUEST_REQUEST,
        payload: true,
      });
   
      let OPTION = {
        url: `${process.env.REACT_APP_API_PATH}/ebench/get_jobs_request?candidateId=${id}&jobAcceptanceStatus=`,
        method: "GET",
        headers: {
          "content-type": "application/json", 
        },
      };
      axios(OPTION)
        .then((res) => {
          dispatch(loadAllDetailsPre(res.data));
        })
        .catch((error) => {
          dispatch({
            type: JOB_REQUEST_FAIL,
            payload: false,
            error: error,
            msg: "Failed to load the information",
          });
        });
    };
  };
  export const loadAllDetailsPre = (data) => {
    return {
      type: JOB_REQUEST_SUCCESS,
      result: data,
      payload: false,
      msg: "SUCCESS",
    };
  };
  